export function groupBy<A,B>(tuples: [A,B][]): Map<A,B[]> {
    const map = new Map<A,B[]>();

    tuples.forEach(t => {
        const [k,v] = t;
        let ex = map.get(k)
        if(!ex) {
            ex = [];
            map.set(k,ex);
        }
        ex.push(v);
    });


    return map;
}